/* eslint-disable max-len */
import React from 'react';

export const LogoSvg = ({ width = 32, height = 36 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2_2)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.4475 10.7354C31.4475 9.54683 30.6094 8.08209 29.5865 7.48012L17.6358 0.451438C16.611 -0.150479 14.9367 -0.150479 13.9119 0.451438L1.96121 7.48012C0.936428 8.08209 0.10022 9.54683 0.10022 10.7354V24.8538C0.10022 26.0424 0.938335 27.5072 1.96121 28.1091L13.9119 35.1378C14.9367 35.7398 16.611 35.7398 17.6358 35.1378L29.5865 28.1091C30.6113 27.5072 31.4475 26.0424 31.4475 24.8538V10.7354Z"
                    fill="#FFC200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.4475 10.7354C31.4475 9.54683 30.6094 8.08209 29.5865 7.48012L17.6358 0.451438C16.611 -0.150479 14.9367 -0.150479 13.9119 0.451438L1.96121 7.48012C0.936428 8.08209 0.10022 9.54683 0.10022 10.7354V24.8538C0.10022 26.0424 0.938335 27.5072 1.96121 28.1091L13.9119 35.1378C14.9367 35.7398 16.611 35.7398 17.6358 35.1378L29.5865 28.1091C30.6113 27.5072 31.4475 26.0424 31.4475 24.8538V10.7354Z"
                    fill="url(#paint0_linear_2_2)"
                />
                <path
                    d="M25.8018 10.9259L19.5617 7.21348C18.7484 6.72966 17.6969 6.99631 17.2111 7.80966C16.7273 8.62302 16.994 9.67446 17.8074 10.1602L23.2094 13.3736V22.309L17.8265 25.4176C17.0074 25.8919 16.7255 26.9396 17.1998 27.7587C17.5178 28.3091 18.0931 28.6158 18.6855 28.6158C18.9769 28.6158 19.2722 28.5415 19.5407 28.3853L25.7809 24.7814C26.3104 24.4748 26.638 23.909 26.638 23.2976V12.3964C26.638 11.7945 26.3199 11.2345 25.8018 10.9259ZM13.7178 25.4195L8.33483 22.3109V13.3755L13.7368 10.1621C14.5502 9.67828 14.8188 8.62683 14.333 7.81157C13.8492 6.99822 12.7959 6.73151 11.9825 7.21539L5.74239 10.9278C5.22238 11.2364 4.9043 11.7964 4.9043 12.4022V23.3033C4.9043 23.9147 5.23002 24.4823 5.76145 24.7871L12.0016 28.391C12.2721 28.5472 12.5654 28.6215 12.8568 28.6215C13.4492 28.6215 14.0245 28.3148 14.3426 27.7643C14.8188 26.9415 14.5388 25.8919 13.7178 25.4195Z"
                    fill="white"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_2_2"
                    x1="23.7476"
                    y1="3.98189"
                    x2="7.797"
                    y2="31.609"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset="1.86995e-07"
                        stopColor="white"
                        stopOpacity="0.4"
                    />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <clipPath id="clip0_2_2">
                    <rect width="32" height="35.6923" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
